import { render } from "./New.vue?vue&type=template&id=3d8ae5f6&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=3d8ae5f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d8ae5f6"

export default script